import { render, staticRenderFns } from "./ComparativeDataNoComparisonAlert.vue?vue&type=template&id=14d71350&scoped=true&"
import script from "./ComparativeDataNoComparisonAlert.vue?vue&type=script&lang=ts&"
export * from "./ComparativeDataNoComparisonAlert.vue?vue&type=script&lang=ts&"
import style0 from "./ComparativeDataNoComparisonAlert.vue?vue&type=style&index=0&id=14d71350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d71350",
  null
  
)

export default component.exports